import React, {useContext, useReducer} from 'react';
import CallStateStream from "../../graphql/subscription/CallStateStream";
import {Card, CardContent} from "@/components/ui/card";
import {Alert, AlertDescription, AlertTitle} from "@/components/ui/alert";
import {CallRow, reduceCallEvent} from "../../graphql/subscription/callRow";
import {OAuthContext} from "../oauth/Provider";
import {Navigate} from "react-router-dom";
import ActivityList from "./ActivityList";
import HeaderBar from "./HeaderBar";
import {ExclamationTriangleIcon} from "@radix-ui/react-icons";
import {GlobalContext} from "../../../state/GlobalProvider";

interface QQState {
    status: CallRow[];
    error?: string;
    showConfig: boolean;
}

const reducer = (state: QQState, action: any) => {
    switch(action.type) {
        case 'CALL_STATE':
            let status = state.status.filter((v) => v.channelId !== action.data.channelId);
            switch (action.data.channelCallState) {
                case 'HANGUP':
                    break;
                default:
                    status.push(action.data);
            }
            return { ...state, status }
        case 'CALL_EVENT':
            return { ...state, status: reduceCallEvent(state.status, action.data) }
        case 'ERROR':
            return { ...state, error: action.data }
    }
    return state;
}

export default function Activity() {
    const oauthCtx = useContext(OAuthContext);
    const { wsConnected } = useContext(GlobalContext);

    const [ state, dispatch ] = useReducer(reducer, { status: [], showConfig: false });

    // If QQCatalyst is not logged in redirect
    if (!oauthCtx.token) {
        return <Navigate to={"/qqcatalyst/oauth/init"} replace />
    }

    return (
        <CallStateStream dispatch={dispatch}>
            <div className="min-h-screen bg-shell text-foreground">
                <HeaderBar connected={wsConnected} />
                <main className="mx-auto w-full max-w-3xl px-4 py-6 sm:px-6 sm:py-10">
                    {!wsConnected ? (
                        <Alert variant="destructive">
                            <ExclamationTriangleIcon className="h-4 w-4" />
                            <AlertTitle>Network Connection Lost</AlertTitle>
                            <AlertDescription>Connection lost, reconnecting ...</AlertDescription>
                        </Alert>
                    ) : (
                        <Card className="shell-panel overflow-hidden border-border/70 bg-card/90 backdrop-blur-xl">
                            <CardContent className="p-0">
                                <ActivityList status={state.status} />
                            </CardContent>
                        </Card>
                    )}
                </main>
            </div>
        </CallStateStream>
    );
}
